import { Mat4, Quat, Vec3, type Entity } from 'playcanvas';

/** Bake overlay transforms into canonical coordinates before packaging spatial layers. */
export const canonicalSceneSettings = (input: Record<string, unknown>, sourceRoot?: Entity): Record<string, unknown> => {
    const settings = structuredClone(input);
    const transform = (settings.cameraPosesTransform ?? {}) as { position?: number[]; rotation?: [number, number, number]; scale?: number };
    const scale = transform.scale ?? 1;
    const matrix = new Mat4().setTRS(new Vec3(transform.position ?? [0, 0, 0]),
        new Quat().setFromEulerAngles(...(transform.rotation ?? [0, 0, 0])), new Vec3(scale, scale, scale));
    const colmap = settings.cameraPosesSpace === 'colmap';
    if (colmap) {
        const sourceMatrix = sourceRoot?.getWorldTransform() ?? new Mat4().setFromEulerAngles(0, 0, 180);
        matrix.mul2(sourceMatrix, matrix);
    }
    const effectiveScale = matrix.getScale().x;
    const invert = colmap !== !!settings.cameraPosesInvertDirection;
    const point = (p: number[]) => matrix.transformPoint(new Vec3(p)).toArray();
    settings.cameraPoses = ((settings.cameraPoses ?? []) as Record<string, unknown>[]).map(pose => ({
        ...pose,
        position: point(pose.position as number[]),
        target: point(pose.target as number[]),
        up: matrix.transformVector(new Vec3((pose.up as number[]) ?? [0, 1, 0])).normalize().toArray(),
        scale: Number(pose.scale ?? 1) * effectiveScale,
        lineWidth: Number(pose.lineWidth ?? settings.cameraPosesLineWidth ?? 0.04) * effectiveScale
    }));
    settings.cameraPosesSpace = 'viewer';
    settings.cameraPosesInvertDirection = invert;
    settings.cameraPosesTransform = { position: [0, 0, 0], rotation: [0, 0, 0], scale: 1 };
    delete settings.cameraPosesUrl;
    return settings;
};
